import { Range } from "immutable";
import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { ClipLoader } from "react-spinners";
import { useWindowSize } from "@utils/hooks";
import { Gallery } from "@ui/components/media/gallery";
import { useFitHorizontal } from "./hooks";
import { pdfDocumentOptions } from "./pdfDocumentOptions";

interface ZoomedPdfViewerProps {
	source: string;
	onClose: () => void;
}
export const ZoomedPdfViewer: React.FC<ZoomedPdfViewerProps> = ({ source, onClose }) => {
	const [pageWidth, setPageWidth] = useState(0);
	const [pageHeight, setPageHeight] = useState(0);
	const { width: windowW, height: windowH } = useWindowSize();

	const zoomFitHorizontal = useFitHorizontal(pageWidth, pageHeight, windowW, windowH);
	const [pagesCount, setPagesCount] = useState<number | null>(null);

	return (
		<Document
			file={source}
			options={pdfDocumentOptions}
			onLoadSuccess={(infos) => setPagesCount(infos.numPages)}
			loading={<ClipLoader />}
		>
			<Gallery
				loop={false}
				onClose={onClose}
				items={Range(1, (pagesCount ?? 1) + 1).toArray()}
				renderItem={(page) => (
					<Page
						key={page}
						pageNumber={page}
						renderAnnotationLayer={false}
						renderTextLayer={false}
						onLoadSuccess={(page) => {
							setPageWidth(page.width);
							setPageHeight(page.height);
						}}
						width={zoomFitHorizontal ? window.innerWidth * 0.9 : undefined}
						height={!zoomFitHorizontal ? window.innerHeight * 0.9 : undefined}
					/>
				)}
			/>
		</Document>
	);
};
